import { Connection } from '@3d-scene/model3d/connection';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { SimpleTextValueVO, TextureAreaUsageVO } from '@shared/vo/meta-element.vo';
import { HtmlUtils } from '@shared/util/html-utils';
import { UniformDirectPrintingModel } from './uniform-direct-printing.model';
import { UniformDirectPrintingService } from './uniform-direct-printing.service';
import { IOperation } from '@shared/undo/operation/i-operation';

export class ActivateUniformDirectPrintingOperation implements IOperation {

  private _connectionAndSize: { connection: Connection, fontSize: number }[] = [];

  constructor(
    private readonly uniformDirectPrintingService: UniformDirectPrintingService,
    private readonly uniformDirectPrintingModel: UniformDirectPrintingModel,
    private readonly applicationRefreshService: ApplicationRefreshService,
  ) {
  }

  public getQualifiedClassName(): string {
    return ActivateUniformDirectPrintingOperation.name;
  }

  public async performRedo(): Promise<void> {
    this._connectionAndSize = [];
    this.uniformDirectPrintingModel.useUniformDirectPrintingFontSize = true;
    const textCheckConnections = this.uniformDirectPrintingService.getTextCheckConnections();
    const success = await this.uniformDirectPrintingService.loadTextCheckInfos(textCheckConnections);
    const uniformFontSize = success ? await this.uniformDirectPrintingService.calculateUniformFontSize(textCheckConnections) : undefined;
    this.uniformDirectPrintingModel.uniformFontSize = uniformFontSize;
    if (uniformFontSize) {
      this.setUniformFontSize(textCheckConnections, uniformFontSize);
      await this.applicationRefreshService.refreshProject();
    }
  }

  public async performUndo(): Promise<void> {
    this.uniformDirectPrintingModel.useUniformDirectPrintingFontSize = false;
    this.uniformDirectPrintingModel.uniformFontSize = undefined;
    for (const { connection, fontSize } of this._connectionAndSize) {
      const textValue = (connection.metaElementUsage as TextureAreaUsageVO).textValue as SimpleTextValueVO;
      textValue.text = HtmlUtils.updateLegacyFontParagraphFontSize(textValue.text, { fontSize });
      connection.isTextureLoaded = false;
    }
    await this.applicationRefreshService.refreshProject();
  }

  public getOperationDescription(): string {
    return '';
  }

  private setUniformFontSize(textCheckConnections: Connection[], uniformFontSize: number) {
    for (const textCheckConnection of textCheckConnections) {

      if (textCheckConnection.metaElementUsage instanceof TextureAreaUsageVO) {
        if (textCheckConnection.metaElementUsage.textValue instanceof SimpleTextValueVO) {
          this.storeFontSizeForUndo(textCheckConnection, textCheckConnection.metaElementUsage.textValue);
          textCheckConnection.metaElementUsage.textValue.text = HtmlUtils.updateLegacyFontParagraphFontSize(textCheckConnection.metaElementUsage.textValue.text, { fontSize: uniformFontSize });
          textCheckConnection.isTextureLoaded = false;
        }
      }
    }
  }

  private storeFontSizeForUndo(connection: Connection, textValue: SimpleTextValueVO) {
    const fontSizeValues = HtmlUtils.extractLegacyFontSizeValues(textValue.text);
    if (fontSizeValues.length > 0) {
      this._connectionAndSize.push({ connection, fontSize: Math.max(...fontSizeValues) });
    }
  }
}
